import script from "./WebFooter.vue?vue&type=script&setup=true&lang=js"
export * from "./WebFooter.vue?vue&type=script&setup=true&lang=js"

import "./WebFooter.vue?vue&type=style&index=0&id=4e1c9f86&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4e1c9f86"]])

export default __exports__